import { useMemo } from 'react';
import { ChartProps } from './chart.component';

const useDisabledStates = (historic: ChartProps['historic'], isVehicle0km: boolean, isVehicleArmored: boolean) => {
    const disabled = useMemo(
        () => ({
            fipeNew: !historic?.fipe?.new?.length || isVehicleArmored,
            fipeUsed: !historic?.fipe?.used?.length || isVehicleArmored,
            webmotorsNotArmored: !historic?.wm_average?.not_armored?.length || isVehicle0km,
            webmotorsArmored: !historic?.wm_average?.armored?.length || isVehicle0km,
        }),
        [historic, isVehicle0km, isVehicleArmored],
    );

    return {
        isDisabled: {
            fipe: isVehicle0km ? disabled.fipeNew : disabled.fipeUsed,
            webmotors: isVehicleArmored ? disabled.webmotorsArmored : disabled.webmotorsNotArmored,
            all: disabled.fipeNew && disabled.fipeUsed && disabled.webmotorsArmored && disabled.webmotorsNotArmored,
        },
    };
};

export default useDisabledStates;
